<template>
  <div>
    <v-row justify="center" no-gutters>
      <v-col cols="1"></v-col>
      <v-col cols="9" class="text-h5 text-md-h5 text-lg-h5 font-weight-bold py-2">
        <div>Change Status Confirmation</div>
      </v-col>
      <v-col cols="2" class="text-right">
        <v-btn
          icon
          @click="clearStatusVals()"
          :disabled="status_object.changeStatusLoader"
        >
          <v-icon large>fa-light fa-xmark</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters class="py-1">
      <v-col cols="1"></v-col>
      <v-col cols="11" class="font-weight-bold">
        <div>
          <v-icon color="#F1B300" small class="mr-2"
            >fa-solid fa-triangle-exclamation</v-icon
          >
          Are you sure that you want to change the status to
          <span v-if="currentDevice.status === 'open'">Closed?</span
          ><span v-if="currentDevice.status === 'closed'">Open?</span>
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="py-2">
      <v-col cols="1"></v-col>
      <v-col cols="11" lg="9">
        <div v-if="currentDevice.status === 'open'" class="change-status-desc">
          Changing the status of a registration to Closed will disable certificate
          enrollments for the registered entity and may result in operation disruptions.
          <br />
          To re-enable enrollments, change the status to Open.
        </div>
        <div v-if="currentDevice.status === 'closed'" class="change-status-desc">
          Changing the status of a registration to Open will enable certificate
          enrollments for the registered entity within the specified validity period.
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters v-if="currentDevice.status === 'closed'">
      <v-col cols="1"></v-col>
      <v-col cols="11"> Please specify the registration validity below: </v-col>
    </v-row>

    <v-row no-gutters v-if="currentDevice.status === 'closed'" class="pt-2 px-2">
      <v-col cols="1"></v-col>
      <v-col cols="12" md="10" xl="2" class="text-h6 text-lg-subtitle-1">
        <div>Validity period</div>
      </v-col>
      <slot name="globalRadioType"></slot>
    </v-row>

    <v-row no-gutters v-if="validityType === '1'">
      <v-col cols="1"></v-col>
      <v-col cols="7" md="4" lg="3" class="px-2 px-md-0 ml-md-4">
        <slot name="globalValidity"></slot>
      </v-col>
      <v-col class="py-4 text-subtitle-1 px-md-2" cols="3"
        >days
        <v-icon class="mb-4 ml-2" x-small color="#EA0028">fa-asterisk</v-icon></v-col
      >
    </v-row>

    <v-row no-gutters>
      <v-col cols="4" md="1" lg="1"></v-col>

      <v-col cols="12" md="11" lg="11" class="text-right">
        <div
          class="text-md-center text-lg-center orange--text text--darken-2 mb-2"
          v-if="status_object.changeStatusLoader"
        >
          <v-icon class="orange--text text--darken-2">fa-light fa-file-signature</v-icon>
          Please sign the request using the Personal desktop app.
        </div>
        <v-btn
          v-if="!status_object.changeStatusLoader"
          plain
          @click="clearStatusVals()"
          class="no-status-btn"
          :disabled="status_object.changeStatusLoader"
          >No</v-btn
        >
        <v-btn
          v-if="currentDevice.status === 'open' && !status_object.changeStatusLoader"
          @click="
            changeStatusFunction({
              status: 'closed',
              validity: currentDevice.validity,
              device: currentDevice,
            }),
              (status_object.changeStatusLoader = true)
          "
          :loading="status_object.changeStatusLoader"
          class="yes-status-btn"
          >Yes
        </v-btn>
        <v-btn
          v-if="currentDevice.status === 'closed' && !status_object.changeStatusLoader"
          @click="
            changeStatusFunction({
              status: 'open',
              validity: validityDuration,
              device: currentDevice,
            }),
              (status_object.changeStatusLoader = true)
          "
          :loading="status_object.changeStatusLoader"
          :disabled="validityType === ''"
          class="yes-status-btn"
          >Yes
        </v-btn>
      </v-col>
    </v-row>
    <div class="pending-sign">
      <v-btn
        v-if="status_object.changeStatusLoader"
        elevation="2"
        color="orange"
        class="white--text pr-5 pl-5"
        depressed
        :loading="status_object.changeStatusLoader"
        ><template v-slot:loader
          ><span>
            <v-icon color="white" class="ml-1 mr-1 icn-spinner"
              >fa-light fa-spinner-third</v-icon
            > </span
          >Pending signature...</template
        >Pending signature...</v-btn
      >
    </div>
  </div>
</template>
<script>
export default {
  props: ["status_object", "currentDevice", "validityType", "validityDuration"],
  data() {
    return {
    };
  },
  methods: {
    clearStatusVals() {
      this.$emit("clearStatusVals");
    },
    changeStatusFunction({ status, validity, device }) {
      this.$emit("changeStatusFunction", { status, validity, device });
    },
  },
};
</script>
<style scope lang="scss">
.change-status-desc {
  width: 100%;
}

.no-status-btn {
  color: #1c3284;
}
.yes-status-btn {
  background-color: #487a7b !important;
  color: #ffffff !important;
}

.pending-sign {
  opacity: 50%;
  text-align: center;
}

.icn-spinner {
  animation: spin-animation 1s linear infinite;
  display: inline-block;
}

@keyframes spin-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
